import * as DevTools from "@effect/experimental/DevTools";
import { BunSocket } from "@effect/platform-bun";
import { Layer } from "effect";

/**
 * DevTools layer for development
 */
export function createDevToolsLayer(enableDevTools: boolean) {
  return enableDevTools
    ? DevTools.layerWebSocket().pipe(Layer.provide(BunSocket.layerWebSocketConstructor))
    : Layer.empty;
}
